
$(document).ready(function () {


	(function ($) {


		var form = $("#kontaktformular-neu");
		form.submit(function (event) {

			var checkObj = { valid: true };
			validateField($("#vorname"), isEmpty, checkObj);
			validateField($("#nachname"), isEmpty, checkObj);
			validateField($("#email"), isEmpty, checkObj);
			validateField($("#country"), isEmpty, checkObj);
			validateField($("#email"), validEmail, checkObj);
			validateField($("#message"), isEmpty, checkObj);
			validateField($("#privacy"), isChecked, checkObj);
			validateField($("#captcha"), isEmpty, checkObj);
			event.preventDefault();

			//console.log("checking off!");


			if (!checkObj.valid) {
				// $("#form-box-error").css("display", "block").fadeIn();
				// $("#form-box-error").slideDown({duration:500, easing:"easeOutCubic"});

				// console.log("form error!");
				showValidationErrorMsg();


			}
			else {
				var formData = form.serialize();
				// console.log("form submit!");
				// console.log("data:", JSON.stringify(formData));

				form.fadeOut();
				$("#form-box-error").fadeOut();

				var failFunction = function (response) {
					// console.log("form fail", response);

					if (response.status == "403") {
						form.fadeIn();

						$("#captcha").val('');
						validateField($("#captcha"), function (field) { return true }, {});
						showValidationErrorMsg();
						// console.log("WRONG CAPTCHA");
					}
					else {
						$("#form-box-backend-error").css("display", "block").animate({
							opacity: 1,
						}, 500);
					}

				};

				$.ajax({
					type: 'POST',
					url: form.attr('action'),
					data: formData
				})
					.done(function (response) {

						if (response == "ok") {
							$("#form-box-success").fadeIn("slow");
							// console.log("form success", response);
						}
						else failFunction(response);
						//show success message

						/*
						$('#vorname').val('');
						$('#nachname').val('');
						$('#email').val('');
						$('#message').val('');
						*/
					})
					.fail(function (response) { failFunction(response) });
			}

		});


		function showValidationErrorMsg() {
			if ($("#form-box-error").is(":hidden")) {
				$("#form-box-error").css("height", "0px").css("display", "block").animate({
					opacity: 1,
					height: "33px",
				}, 500);
			}

		}

		function validateField(field, checkFunction, formObj) {

			// console.log("validateField:", field, field.checked, checkFunction, checkFunction(field));

			if (checkFunction(field)) {
				field.addClass("form-error");
				formObj.valid = false;
				field.change(function () {
					if (!checkFunction(field)) {
						field.removeClass("form-error");
					}
				});
			}

		}

		function isEmpty(field) {
			return (field.val() == "")
		}

		function isChecked(field) {
			// console.log(field, "isChecked", field.is(":checked"))
			return (!field.is(":checked"))
		}

		function validEmail(field) {
			var r = new RegExp("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?");
			// var r = new RegExp("^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+(?:[a-zA-Z]{2,})\b$");
			return (field.val().match(r) == null) ? true : false;
		}

		// Test for placeholder support
		if ($.support.placeholder === undefined) {
			$.support.placeholder = (function () {
				var i = document.createElement('input');
				return 'placeholder' in i;
			})();
		}

		var getLabel = function ($input) {

			if ($input.parent().is('label')) {
				return {
					relation: 'parent',
					$node: $input.parent()
				}
			}
			if ($input.prev().is('label')) {
				return {
					relation: 'prev',
					$node: $input.prev()
				}
			}
			if ($input.attr('id') && $('label[for="' + $input.attr('id') + '"]').length === 1) {
				return {
					relation: 'id',
					$node: $('label[for="' + $input.attr('id') + '"]')
				}
			}
			return {
				relation: false,
				$node: false
			}

		};

		if (!$.fn.floatLabel)
			$.fn.floatLabel = function () {


				if (!$.support.placeholder) {
					return this;
				}

				this.each(function () {

					var $this = $(this);

					//if($this.data('float-label-enhanced') === true || (!$this.is('input') && !$this.is('textarea')&& !$this.is('select'))) {
					if ($this.data('float-label-enhanced') === true || (!$this.is('input') && !$this.is('textarea'))) {
						return;
					}

					var placeholder = $this.attr('placeholder'),
						label = getLabel($this),
						floatLabelText = '';

					if ($this.data('float-label') && $this.data('float-label') != '') {
						floatLabelText = $this.data('float-label');
					}

					if (label.$node === false || (label.$node && label.$node.length === 0)) {
						if (floatLabelText === '') {
							if (placeholder && placeholder !== '') {
								floatLabelText = placeholder;
							} else {
								return;
							}
						}
					} else {
						if (floatLabelText === '') {
							floatLabelText = label.$node.text();
						}
						if (label.relation === 'parent') {
							label.$node.contents().filter(function () {
								return this.nodeType == 3;
							}).remove();
						} else {
							label.$node.hide();
						}
					}

					if (floatLabelText === '') {
						return; // no text, no float label
					}

					$this.wrap('<span class="js-float-label hide-label"></span>');

					var $floatLabelBox = $this.parent();

					$floatLabelBox.prepend('<span class="float-label-text" data-text="' + floatLabelText + '"></span>');

					$this.data('float-label-enhanced', true);

					$this
						.on('keyup', function (e) {

							var $e = $(this);

							if ($e.val() === '') {
								$floatLabelBox.addClass('hide-label');
							} else {
								$floatLabelBox.removeClass('hide-label');
							}

						})
						.on('blur', function (e) {

							var $e = $(this);
							//console.log('DEBUG FORM', $e, $e.val() );

							//if ($e.val() === '' || $e.val() === null) {
							if ($e.val() === '') {
								$floatLabelBox.addClass('hide-label');
							} else {
								$floatLabelBox.removeClass('hide-label').addClass('js-unhighlight-label');
							}

						})
						.on('focus', function (e) {

							var $e = $(this);

							if ($e.val() !== '') {
								$floatLabelBox.removeClass('js-unhighlight-label');
							}

						});

					if ($this.val() !== '') {
						$floatLabelBox.removeClass('hide-label').addClass('js-unhighlight-label');
					}

				});

				return this;

			};

		if (!$.fn.dropDown)
			$.fn.dropDown = function () {
				var $this = $(this);
				$this
					.on('change', function (e) {

						var $e = $(this);
						//console.log('DEBUG FORM', $e, $e.val() );

						if ($e.val() !== null) {
							$this.removeClass('dropLabel');
						} else {
							//ELSE?
						}

					})

			}


		// data-api auto init
		$(function () {
			$('[data-float-label]').floatLabel();
			$('#country').dropDown();
		});




	})(jQuery);


	window.refreshCaptcha = function () {
		document.getElementById('captchaImage').src = '/wp-content/themes/coco/lib/captcha.php?' + Date.now();
		// console.log("refreshCaptcha");
	}


}); //end document ready
